/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ site: NonNullable<unknown>, value: NonNullable<unknown> }} Body_Measures_Saved_ChipInputs */

const en_us2_body_measures_saved_chip = /** @type {(inputs: Body_Measures_Saved_ChipInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.site}, just logged: ${i?.value} cm`)
};

const pt_br2_body_measures_saved_chip = /** @type {(inputs: Body_Measures_Saved_ChipInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.site}, registrado agora: ${i?.value} cm`)
};

const es_419_body_measures_saved_chip = /** @type {(inputs: Body_Measures_Saved_ChipInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.site}, recién registrado: ${i?.value} cm`)
};

const pt_pt2_body_measures_saved_chip = /** @type {(inputs: Body_Measures_Saved_ChipInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.site}, registado agora: ${i?.value} cm`)
};

const fr_fr2_body_measures_saved_chip = /** @type {(inputs: Body_Measures_Saved_ChipInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.site}, à l'instant : ${i?.value} cm`)
};

const de_de2_body_measures_saved_chip = /** @type {(inputs: Body_Measures_Saved_ChipInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.site}, gerade eingetragen: ${i?.value} cm`)
};

const it_it2_body_measures_saved_chip = /** @type {(inputs: Body_Measures_Saved_ChipInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.site}, appena registrato: ${i?.value} cm`)
};

/**
* | output |
* | --- |
* | "{site}, just logged: {value} cm" |
*
* @param {Body_Measures_Saved_ChipInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_measures_saved_chip = /** @type {((inputs: Body_Measures_Saved_ChipInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Measures_Saved_ChipInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_measures_saved_chip(inputs)
	if (locale === "es-419") return es_419_body_measures_saved_chip(inputs)
	if (locale === "pt-PT") return pt_pt2_body_measures_saved_chip(inputs)
	if (locale === "fr-FR") return fr_fr2_body_measures_saved_chip(inputs)
	if (locale === "de-DE") return de_de2_body_measures_saved_chip(inputs)
	if (locale === "it-IT") return it_it2_body_measures_saved_chip(inputs)
	return en_us2_body_measures_saved_chip(inputs)
});
export { body_measures_saved_chip as "body-measures.saved_chip" }